/**
 * Map an asset mime type to the short subtype label shown on `asset` nodes
 * in the knowledge graph: 'image' | 'audio' | 'data/json' | 'data/xml' | …
 */
export function mimeToAssetSubtype(mimeType: string): string {
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType.startsWith('audio/')) return 'audio';
  if (mimeType === 'application/json') return 'data/json';
  if (mimeType.startsWith('application/')) return 'data/' + mimeType.slice('application/'.length);
  return mimeType;
}
